import { Divider, Flex, Col, Typography } from "antd";
import { DisplayAmount } from "ui";
import { RUB_CURRENCY } from "utils";

interface Props {
  amount: number;
}

export const OtpModalTitle = ({ amount }: Props) => (
  <>
    <Divider className="margin-top-none" />
    <Flex justify="space-between">
      <Col>
        <Typography.Text strong className="text-lg">
          Сумма
        </Typography.Text>
      </Col>
      <Col>
        <Typography.Text strong className="text-lg">
          <DisplayAmount amount={amount} currency={RUB_CURRENCY.RUB} />
        </Typography.Text>
      </Col>
    </Flex>
    <Divider />
  </>
);
